<template>
<div>edit</div>
</template>

<script>
export default {
  name: 'PersonEditOrgReservation',
}
</script>

<style scoped>

</style>
